var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5578_31284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4012 4.11719H4.58282V17.5853H19.4012V4.11719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.992 11.9997C23.992 18.6183 18.6231 23.9837 12 23.9837C5.377 23.9837 0.00799561 18.6183 0.00799561 11.9997C0.00799561 5.38106 5.377 0.015625 12 0.015625C18.6231 0.015625 23.992 5.38106 23.992 11.9997ZM8.60182 16.7687H6.2745C5.78546 16.7687 5.5439 16.7687 5.39661 16.6746C5.23752 16.5715 5.14031 16.4007 5.12852 16.2123C5.11968 16.0387 5.24047 15.8266 5.48204 15.4027L11.2285 5.28055C11.473 4.85072 11.5967 4.6358 11.7528 4.55632C11.9208 4.47094 12.1211 4.47094 12.289 4.55632C12.4452 4.6358 12.5689 4.85072 12.8134 5.28055L13.9947 7.34135L14.0008 7.35187C14.2649 7.81299 14.3988 8.04683 14.4573 8.29226C14.5221 8.56017 14.5221 8.84279 14.4573 9.1107C14.3983 9.35799 14.2658 9.59352 13.9977 10.0616L10.9792 15.3938L10.9714 15.4075C10.7056 15.8724 10.5709 16.1081 10.3841 16.2858C10.1809 16.4802 9.93635 16.6214 9.66826 16.701C9.42374 16.7687 9.14978 16.7687 8.60182 16.7687ZM14.4791 16.7687H17.8138C18.3058 16.7687 18.5533 16.7687 18.7007 16.6717C18.8597 16.5686 18.9599 16.3948 18.9688 16.2065C18.9773 16.0385 18.8591 15.8347 18.6276 15.4354C18.6196 15.4218 18.6116 15.408 18.6034 15.3939L16.933 12.5382L16.914 12.5061C16.6793 12.1094 16.5608 11.9091 16.4086 11.8317C16.2408 11.7463 16.0433 11.7463 15.8754 11.8317C15.7222 11.9112 15.5985 12.1202 15.354 12.5412L13.6895 15.3969L13.6838 15.4067C13.4402 15.827 13.3184 16.0371 13.3272 16.2094C13.339 16.3979 13.4362 16.5715 13.5953 16.6746C13.7396 16.7687 13.9871 16.7687 14.4791 16.7687Z",
    fill: "#E84142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5578_31284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.0ca048f6ed209d8c609caaa3dac8adde.svg";
export { ForwardRef as ReactComponent };